export const ADD_USER_VIEW = "ADD_USER_VIEW";
export const GET_VIEWS = "GET_VIEWS";
